import type { FC, ReactNode } from 'react'
import type { LabStatus } from '@/types'

import { cn } from '@/lib/utils'
import { LAB_STATUSES } from '@/constants/taxonomy'

interface ExperimentStatusProps {
    status: LabStatus
    className?: string
    showDescription?: boolean
}

const MARKERS: Record<LabStatus, string> = {
    active: 'bg-success',
    exploring: 'bg-brand',
    archived: 'border border-muted-foreground bg-transparent'
}

const TEXT: Record<LabStatus, string> = {
    active: 'text-success',
    exploring: 'text-brand',
    archived: 'text-muted-foreground'
}

/** Static square marker plus label. No pulsing, no glow: it is a log, not a dashboard. */
const ExperimentStatus: FC<ExperimentStatusProps> = ({ status, className, showDescription = false }): ReactNode => {
    const meta = LAB_STATUSES[status]

    return (
        <span className={cn('inline-flex items-center gap-2 font-mono text-label uppercase', TEXT[status], className)}>
            <span aria-hidden='true' className={cn('size-2 shrink-0', MARKERS[status])} />
            <span>{meta.label}</span>
            {showDescription && <span className='normal-case tracking-normal text-muted-foreground'>{meta.description}</span>}
        </span>
    )
}

export default ExperimentStatus
